import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import * as aboutValuesStyles from "../styles/AboutValues.module.css"

export default function AboutValues(props) {
  const { content } = props

  const cards = ChildSelector.select(
    content,
    `values-card`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(card => ({
    imageHolder: card,
    title: ChildSelector.select(
      card,
      `card-title`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    content: ChildSelector.select(
      card,
      `card-content`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
  }))

  return (
    <>
      {/* <div
        className={`row justify-content-center ${aboutValuesStyles.wrapper}`}
      >
        <div className={`col-3 ${aboutValuesStyles.logo}`}></div>
        <div className={`col-9 ${aboutValuesStyles.content}`}>
          <h4
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {textStack.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
        </div>
      </div> */}

      <div
        className={`row ${aboutValuesStyles.groupwrapper} ${props.className}`}
      >
        {cards &&
          cards.map((c, idx) => (
            <div
              key={idx}
              className={`col-12 col-xl-2 ${aboutValuesStyles.group}`}
            >
              <WPImage
                holder={c.imageHolder}
                selector={`card-image`}
                mode={DISPLAY_MODE.normal}
                className={aboutValuesStyles.logo}
              />
              <h1 className={`${aboutValuesStyles.title}`}>{c.title}</h1>
              <p className={`${aboutValuesStyles.content}`}>{c.content}</p>
            </div>
          ))}
      </div>
    </>
  )
}
